import { z } from "zod";

import useTranslation from "../../hooks/useTranslation";
import { createUserNameSchemaWithTranslations } from "../../hooks/useUpdateName";
import validatePassword from "../../lib/PasswordValidator";
import { isEmailInvalid } from "../../utils/validationUtils";

export type SignUpFormData = {
  email: string;
  password: string;
  passwordConfirm: string;
  name: string;
  terms: boolean;
};

export const useSignupSchema = () => {
  const { t, m } = useTranslation();
  const nameSchema = createUserNameSchemaWithTranslations(t);

  return z
    .object({
      email: z
        .string()
        .min(1, t(m.ErrorMessage.InvalidEmail))
        .refine((val) => !isEmailInvalid(val), {
          message: t(m.ErrorMessage.InvalidEmail),
        }),
      password: z
        .string()
        .min(1, t(m.ErrorMessage.InvalidPassword))
        .max(72, t(m.ErrorMessage.TooLongPassword))
        .refine((val) => validatePassword(val).valid, {
          message: t(m.ErrorMessage.WeakPassword),
        }),
      passwordConfirm: z.string().min(1, t(m.ErrorMessage.PasswordsDontMatch)),
      name: nameSchema,
      terms: z.boolean().refine((val) => val, {
        message: t(m.ErrorMessage.TermsAndPrivacyNotAccepted),
      }),
    })
    .refine((data) => data.password === data.passwordConfirm, {
      message: t(m.ErrorMessage.PasswordsDontMatch),
      path: ["passwordConfirm"],
    });
};
